export const GUIDE_HEIGHT = 88;
export const TITLE_WIDTH = 100;
export const TITLE_HEIGHT = 13;
